import { render, staticRenderFns } from "./FeesForPaidPassengersPage.vue?vue&type=template&id=60303611&scoped=true&"
import script from "./FeesForPaidPassengersPage.vue?vue&type=script&lang=js&"
export * from "./FeesForPaidPassengersPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForPaidPassengersPage.vue?vue&type=style&index=0&id=60303611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60303611",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60303611')) {
      api.createRecord('60303611', component.options)
    } else {
      api.reload('60303611', component.options)
    }
    module.hot.accept("./FeesForPaidPassengersPage.vue?vue&type=template&id=60303611&scoped=true&", function () {
      api.rerender('60303611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/calculation/feesForPaidPassengers/FeesForPaidPassengersPage.vue"
export default component.exports